export const firebaseConfig = {
  apiKey: "AIzaSyDbpgWQHHwElcgAsIaHnn1BvMxbE-5kXMY",
  authDomain: "jpg-studio.firebaseapp.com",
  projectId: "jpg-studio",
  storageBucket: "jpg-studio.appspot.com",
  messagingSenderId: "1022839092068",
  appId: "1:1022839092068:web:6d63e0ca814b6e19ca4071"
};